/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {OverflowOptionPickerRequest} from '@cash-web/protos/squareup/franklin/app/overflow_option_picker.pb'
import {OverflowOptionPickerResponse} from '@cash-web/protos/squareup/franklin/app/overflow_option_picker.pb'


export const submitOverflowOptionSelection = (request: OverflowOptionPickerRequest, options?: CashRequestOptions) => post<OverflowOptionPickerRequest, OverflowOptionPickerResponse>("/2.0/cash/submit-overflow-option-selection", request, {...options, rejectOnError: true })